import {
  Profiles,
  Moods,
} from './enums';
import StudentDefault from './components/student/StudentDefault';
import StudentHappy from './components/student/StudentHappy';
import EmployeeDefault from './components/employee/EmployeeDefault';
import EmployeeHappy from './components/employee/EmployeeHappy';
import EmployeeSurprise from './components/employee/EmployeeSurprise';
import StudentSurprise from './components/student/StudentSurprise';
import MentorDefault from './components/mentor/MentorDefault';
import MentorHappy from './components/mentor/MentorHappy';
import MentorSurprise from './components/mentor/MentorSurprise';
import SchoolCoachDefault from './components/school-coach/SchoolCoachDefault';
import SchoolCoachHappy from './components/school-coach/SchoolCoachHappy';
import SchoolCoachSurprise from './components/school-coach/SchoolCoachSurprise';
import CompanyAdminDefault from './components/company-admin/CompanyAdminDefault';
import CompanyAdminHappy from './components/company-admin/CompanyAdminHappy';
import CompanyAdminSurprise from './components/company-admin/CompanyAdminSurprise';
import MJGAdminDefault from './components/mjg-admin/MJGAdminDefault';
import MJGAdminHappy from './components/mjg-admin/MJGAdminHappy';
import MJGAdminSurprise from './components/mjg-admin/MJGAdminSurprise';
import ModeratorDefault from './components/moderator/ModeratorDefault';
import ModeratorSurprise from './components/moderator/ModeratorSurprise';
import ModeratorHappy from './components/moderator/ModeratorHappy';

export const allAvatars = {
  [Profiles.student]: {
    [Moods.default]: StudentDefault,
    [Moods.happy]: StudentHappy,
    [Moods.surprise]: StudentSurprise,
  },
  [Profiles.mentor]: {
    [Moods.default]: MentorDefault,
    [Moods.happy]: MentorHappy,
    [Moods.surprise]: MentorSurprise,
  },
  [Profiles.employee]: {
    [Moods.default]: EmployeeDefault,
    [Moods.happy]: EmployeeHappy,
    [Moods.surprise]: EmployeeSurprise,
  },
  [Profiles['school-coach']]: {
    [Moods.default]: SchoolCoachDefault,
    [Moods.happy]: SchoolCoachHappy,
    [Moods.surprise]: SchoolCoachSurprise,
  },
  [Profiles['company-admin']]: {
    [Moods.default]: CompanyAdminDefault,
    [Moods.happy]: CompanyAdminHappy,
    [Moods.surprise]: CompanyAdminSurprise,
  },
  [Profiles['mjg-admin']]: {
    [Moods.default]: MJGAdminDefault,
    [Moods.happy]: MJGAdminHappy,
    [Moods.surprise]: MJGAdminSurprise,
  },
  [Profiles.moderator]: {
    [Moods.default]: ModeratorDefault,
    [Moods.happy]: ModeratorHappy,
    [Moods.surprise]: ModeratorSurprise,
  },
};
